import { Card } from 'antd'
import { useJourneyHistoryFragment } from '~/gql/generated/graphql'
import Timeline, { TimelineHistoryItem } from '../Timeline'
import { IDProps } from './Set'

const History = ({ id }: IDProps) => {
  const { data } = useJourneyHistoryFragment({
    id,
  })
  if (!data) {
    return null
  }
  const items = (data?.state_history?.nodes ?? []) as TimelineHistoryItem[]

  return (
    <Card id="journey-history-card">
      <Timeline items={items} />
    </Card>
  )
}

export default History
